import { db } from './../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';

export const SET_HITOS = 'SET_HITOS';

const setHitos = payload => ({ type: SET_HITOS, payload });

export const setHitosToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.HITOS}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var hitosSnap = snapshot.val();
                    var hitos = [];
                    hitosSnap.forEach(hito => {
                        hitos.push(hito);
                    });
                    dispatch(setHitos(hitos));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setHitos([]));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setHitos([]));
        });
    };
};